<template>
  <div
    class="empty-records"
  >
    <div
      v-if="loading"
      class="col-xs-12"
    >
      <div class="loader-container">
        <div class="loader" />
      </div>
      <slot>
        {{ $t('LOADING_TEXT') }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  i18n: {
    messages: {
      en: {
        LOADING_TEXT: 'Loading'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-records {
  height: auto;
  padding: 50px 0;
}
</style>